// extracted by mini-css-extract-plugin
module.exports = {"title":"title--3SPVf","successInfo":"successInfo--24ZsR"};